import { render, staticRenderFns } from "./EmberPage.vue?vue&type=template&id=06448e14&scoped=true&"
import script from "./EmberPage.vue?vue&type=script&lang=js&"
export * from "./EmberPage.vue?vue&type=script&lang=js&"
import style0 from "./EmberPage.vue?vue&type=style&index=0&id=06448e14&lang=scss&scoped=true&"
import style1 from "./EmberPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06448e14",
  null
  
)

export default component.exports